export default {
      id: "couvert-avec-averses-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#couvert-avec-averses-usage",
      toString: function () {
        return this.url;
      }
    }